export enum Screens {
  HOME = '/home',
  //Admin Screens
  ADMIN = '/admin',
  ADMIN_SEARCH = '/admin/search',
  USER_ADMIN = '/admin/user-admin',
  LOCATION_ADMIN = '/admin/location-admin',
  LOCATION_GROUP = '/admin/location-group',
  ROUTE_ADMIN = '/admin/route-admin',
  DEVICE_ADMIN = '/admin/device-admin',
  ADL = '/admin/access-point',
  BUILDING_SCAN_ADMIN = '/admin/building-scan',
  ///
  //Operations Screens
  OPERATIONS = '/operations',
  ROUTE_SUMMARY = '/operations/route-summary',
  PICKUP_ASSIGNMENT = '/operations/pickup-assignment',
  ///
  //Exceptions Screens
  EXCEPTIONS_GROUP = '/exceptions',
  BUILDING_SCAN_EXCEPTIONS = '/exceptions/building-scan',
  INTERCEPTS = '/exceptions/intercepts',
  EXCEPTIONS = '/exceptions/exceptions',
  PRINT_SHIPPING_LABEL = '/exceptions/print-shipping-label',
  ///
  REPORTS = '/reports',
  FILE_UPLOAD = '/file-upload',
  LOGOUT = '/logout',
  //Not Technically a Screen but including here anyway for role permissions://
  TRACKINGNUMBERSEARCH = '/trackingnumbersearch',
  ///////
}

export enum Reports {
  //On-road Operations//
  DRIVER_LOAD_REPORT,
  DELIVERY_MANIFEST,
  PICKUP_MANIFEST,
  LOAD_DISCREPANCY_REPORT,
  SEND_AGAIN,
  DRY_ICE,
  //////////////////////
  //CODs//
  COD_OUT_FOR_DELIVERY,
  COD_RECONCILE,
  COD_RECONCILE_REPORT,
  COD_COLLECTED_CLEARED,
  GROUP_COD_EXTRACT,
  COD_OUTSTANDING,
  //////////////////////
  //Exceptions Reports//
  HANDOVER_SCAN_REPORT,
  EXCEPTION_PROCESSING_REPORT,
  BUILDING_SCAN_EXPORT,
  //////////////////////
  //Summaries//
  LOCATION_SUMMARY,
  GROUP_SUMMARY,
  //////////////////////
  //Inventory//
  LOCATION_INVENTORY,
  GROUP_INVENTORY,
  //////////////////////
  //Errors//
  LOCATION_ERROR_REPORT,
  GROUP_ERROR_REPORT,
  //////////////////////
  //Other//
  AGED_PACKAGE_STATUS,
  RETAIL_ACTIVITY_REPORT,
  NON_UPS_BARCODE_EXTRACT,
  AGED_RETAIL_STATUS,
  PACKAGE_NOT_FOUND,
  //////////////////////
  //IDO//
  LOCATION_FORECAST,
  GROUP_FORECAST,
  LOCATION_EDW,
  GROUP_EDW,
  //////////////////////
}

export enum ReportCluster {
  ONROAD_OPERATIONS,
  CODS,
  EXCEPTIONS_REPORTS,
  SUMMARIES,
  INVENTORY,
  ERRORS,
  OTHER,
  IDO,
}
